// extracted by mini-css-extract-plugin
export default {"Toast":"Toast_Toast__1eyOL","EDocToast":"Toast_EDocToast__LCf+I"};